<template>
    <div class="settings-page">
        <div class="profile-settings flex">
            <div class="left-portion"
                 @dragenter.prevent="dragEnter"
                 @dragleave.prevent="dragLeave"  
                 @dragover.prevent
                 @drop.prevent>
                <div class="logo__cover flex">
                    <div class="logo">
                        <div class="drag flex" @drop.prevent="dropImages($event, 'logo')">
                            <span class="secondary-font" v-if="!profileDetails.logo.preview">Drag</span>
                            <input 
                                type="file" 
                                id="details-page-logo-uploader" 
                                style="display : none;"
                                @change="selectImages($event, 'logo')">
                            <div class="image" v-if="profileDetails.logo.preview">
                                <img :src="profileDetails.logo.preview" alt="Drag">
                                <v-icon 
                                    color="white" 
                                    small 
                                    class="pointer delete-image" 
                                    @click.native="removeLogoOrCover('logo')">
                                    mdi-close
                                </v-icon>
                            </div>
                        </div>
                        <label for="details-page-logo-uploader" class="upload --green --weight flex pointer">Upload new logo</label>
                    </div> 

                    <div class="cover">
                        <div class="drag flex" @drop.prevent="dropImages($event, 'cover')">
                            <span class="secondary-font" v-if="!profileDetails.cover.preview">Drag</span>
                            <input 
                                type="file" 
                                id="details-page-cover-uploader" 
                                style="display : none;"
                                @change="selectImages($event, 'cover')"
                                >
                            <div class="image cover-image" v-if="profileDetails.cover.preview">
                                <img :src="profileDetails.cover.preview" alt="">
                                <v-icon 
                                    color="white" 
                                    small 
                                    class="pointer delete-image"
                                    @click.native="removeLogoOrCover('cover')">
                                    mdi-close
                                </v-icon>
                            </div>
                        </div>
                        <label 
                            for="details-page-cover-uploader" 
                            class="upload --green --weight flex pointer">
                            Upload new cover image
                        </label>
                    </div> 
                </div>

                <div class="forms">
                    <label>Company name</label>
                    <v-textarea 
                        class="mt-1"
                        v-model="profileDetails.name"
                        counter
                        outlined
                        rows="4"
                        height="50"
                        maxlength="80">
                        <template v-slot:counter={props}>
                            <div class="secondary-font counter">
                                {{ props.value }}/80
                            </div>
                        </template>
                    </v-textarea>

                    <label>Company category</label>
                    <v-select 
                        class="mt-1"
                        outlined
                        label="Select company category"
                        v-model="profileDetails.selectedCategory"
                        :items="categories"
                        item-text="display_name"
                        item-value="id" />
                       

                    <label>Company bio</label>
                    <v-textarea 
                        class="mt-1"
                        v-model="profileDetails.description"
                        counter
                        outlined
                        rows="4"
                        height="100"
                        maxlength="1000">
                        <template v-slot:counter={props}>
                            <div class="secondary-font counter">
                                {{ props.value }}/1000
                            </div>
                        </template>
                    </v-textarea>

                    <label>How do you want customers to directly contact you?</label>
                    <div class="flex mb-4" style="justify-content : flex-start; margin-top : -15px;">
                        <v-radio-group row hide-details="" v-model="profileDetails.contactSource">
                            <v-radio color="#419045" value="call">
                                <label slot="label" class="pointer">Phone call</label>
                            </v-radio>
                            <v-radio color="#419045" value="whatsapp">
                                <label slot="label" class="pointer">Whatsapp</label>
                            </v-radio>
                        </v-radio-group>
                    </div>
                    <v-text-field class="mb-4" 
                                  outlined 
                                  dense 
                                  label="Enter your phone no/whatsapp no" 
                                  hide-details 
                                  maxlength="10" 
                                  v-model="phoneNumber">
                    </v-text-field> 

                    <label>Where do you want your consumers to re-direct from your business page?</label>
                    <div class="flex mb-4" style="justify-content : flex-start; margin-top : -15px;">
                        <v-radio-group row hide-details="" v-model="profileDetails.shareSource" >
                            <v-radio color="#419045" class="web" value="web">
                                <label slot="label" class="pointer">Our website</label>
                            </v-radio>
                            <v-radio color="#419045" class="youtube" value="youtube">
                                <label slot="label" class="pointer">YouTube</label>
                            </v-radio>
                            <v-radio color="#419045" class="app_link" value="app_link">
                                <label slot="label" class="pointer">App Link</label>
                            </v-radio>
                        </v-radio-group>
                    </div>
                    <v-text-field outlined dense label="Paste the link here.." hide-details v-model="shareSourceLink">
                    </v-text-field> 
                </div>
            </div>

            <div class="right-portion">
                <mobile-preview ref="mobilePreviewRef" :brandDetails="profileDetails"/>
                <button class="save weight" @click="updateProfileDetails">Save Changes</button>
            </div>
        </div>
        <v-overlay opacity="0.3" color="black" v-if="loader">
            <v-progress-circular indeterminate color="#1F8F58"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import accessToken from '../../../helpers/accessToken';
import API_URL from "../../../helpers/apiUrls";
import navigation from "./components/navigation.vue";
import mobilePreview from "../../FrontPage/components/mobile-preview.vue";
import helper from "../../../helpers/methods";
export default {
    name : "profileSettings",

    data() {
        return {
            profileDetails : {
                name : '',
                description : '',
                logo : {
                    preview : null,
                    image : null
                },
                cover : {
                    preview : null,
                    image : null
                },
                selectedCategory : null,
                contactSource : null,
                shareSource : null,
            },
            categories : [],
            loader : false,
            phoneNumber : null,
            shareSourceLink : null
        }
    },

    created() {
        this.getCompanyCategories();
    },

    methods : {
        getCompanyCategories() {
            const successHandler = response => {
                if(response.status === 200) {
                    this.categories = response.data.brand_categories;
                    this.getProfileDetails();
                }
            }

            const errorHandler = error => {
                console.log(error.data);
            }

            this.requestGET(
                API_URL.brandCategories,
                {},
                {},
                successHandler,
                errorHandler
            )

        },
        
        getProfileDetails() {
            this.loader = true;
            const successHandler = response => {
                if(response.status === 200) {
                    // if(response.data.verification_status !== 'verified') {
                    //     this.$router.replace({ name : 'verifyCurtain' });
                    //     return;
                    // }
                    this.profileDetails.name = response.data.name;
                    this.profileDetails.description = response.data.description;
                    this.profileDetails.logo.preview = response.data.logo_image.original;
                    this.profileDetails.selectedCategory = response.data.brand_category ? response.data.brand_category.id : "Select a category";
                    this.profileDetails.cover.preview = response.data.time_line_image.original;
                    this.$refs.mobilePreviewRef.logoPreview = response.data.logo_image.original;
                    this.$refs.mobilePreviewRef.coverPreview = response.data.time_line_image.original;
                    this.profileDetails.contactSource = response.data.contact_preference;
                 
                    this.phoneNumber = response.data.phone_number;
                    if(response.data.external_link){
                        this.profileDetails.shareSource = response.data.external_link.link_type;
                        this.shareSourceLink = response.data.external_link.value;
                    }
                    if(response.data.is_password_set) {
                        this.$store.state.mainStore.profileNavigationText = "Change Password"
                    }
                    else {
                        this.$store.state.mainStore.profileNavigationText = "Create Password"
                    }
                    this.loader = false;
                }
            }

            const errorHandler = error => {
                this.showToast("Something went wrong internally!", "error", 10000);
                console.log(error);
                this.loader = false;
            }

            const brandID = accessToken.getCredentials().brandID;

            const headers = {
                'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
                'BRAND-ID' : brandID 
            }

            this.requestGET(
                `${API_URL.brand}/${brandID}/_retrieve`,
                {},
                headers,
                successHandler,
                errorHandler
            )
        },

        selectImages(event, type) {
            if(type === 'logo') {
                this.profileDetails.logo.image = event.target.files[0];
                const url = helper.provideImagePreviewURL([event.target.files[0]])[0];
                this.profileDetails.logo.preview = url;
                this.$refs.mobilePreviewRef.logoPreview = url;
            }
            else {
                this.profileDetails.cover.image = event.target.files[0];
                const url = helper.provideImagePreviewURL([event.target.files[0]])[0];
                this.profileDetails.cover.preview = url;
                this.$refs.mobilePreviewRef.coverPreview = url;
            }
        },

        dragEnter() {
            this.isDragged = true;
        },

        dragLeave() {
            this.isDragged = false;
        },

        dropImages(event, type) {
            this.isDragged = false;
            if(event.dataTransfer.files.length > 1) {
                this.showToast('You can only select 1 image here!', 'error', 100000);
                return;
            }

            if(type === 'logo') {
                this.profileDetails.logo.image = event.dataTransfer.files[0];
                const url = helper.provideImagePreviewURL([event.dataTransfer.files[0]])[0];
                this.profileDetails.logo.preview = url;
                this.$refs.mobilePreviewRef.logoPreview = url;
            }
            else {
                this.profileDetails.cover.image = event.dataTransfer.files[0];
                const url = helper.provideImagePreviewURL([event.dataTransfer.files[0]])[0];
                this.profileDetails.cover.preview = url;
                this.$refs.mobilePreviewRef.coverPreview = url;
            }
        },

        removeLogoOrCover(type) {
            if(type === 'logo') {
                this.profileDetails.logo.image = null;
                this.profileDetails.logo.preview = null;
                this.$refs.mobilePreviewRef.logoPreview = null;
            }
            else {
                this.profileDetails.cover.image = null;
                this.profileDetails.cover.preview = null;
                this.$refs.mobilePreviewRef.coverPreview = null;
            }
        },

        updateProfileDetails() {
            this.loader = true;
            const successHandler = response => {
                if(response.status === 200) {
                    this.showToast("Your profile has been successfully updated!");
                    this.loader = false;
                }
            }

            const errorHandler = error => {
                this.toggleLoader(false);
                console.log(error);
            }

            const data = new FormData();

            data.append('name', this.profileDetails.name)
            data.append('description', this.profileDetails.description)
            data.append('brand_category', this.profileDetails.selectedCategory)
            if(this.phoneNumber){
                   data.append("phone_number", this.phoneNumber)
            }
         
            if(this.profileDetails.contactSource){
                data.append("contact_preference", this.profileDetails.contactSource)
            }
         

            if(this.profileDetails.shareSource && this.shareSourceLink){
                 const externalLink = {
                link_type : this.profileDetails.shareSource,
                value : this.shareSourceLink
            }

            data.append("external_link", JSON.stringify(externalLink));
            }
           

            // for (let link in externalLink) {
            //     console.log(link + ":" + externalLink[link]);
            //     data.append(link, externalLink[link])
            // }
            
            if(this.profileDetails.logo.image) 
                data.append('logo_image', this.profileDetails.logo.image)
            if(this.profileDetails.cover.image)
                data.append('time_line_image', this.profileDetails.cover.image)

            const brandID = accessToken.getCredentials().brandID;

            const headers = {
                'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
                'BRAND-ID' : brandID 
            } 

            this.requestPATCH(
                this.$store.getters["mainStore/GET_SUPER_ADMIN"]?`/super-admin/${API_URL.brand}/${brandID}/_partial_update`:  `${API_URL.brand}/${brandID}/_partial_update`,
                data,
                headers,
                successHandler,
                errorHandler
            )
        }
    },

    components : {
        "mobile-preview" : mobilePreview,
        "navigation" : navigation
    }
    
}
</script>

<style lang="scss" scoped>

.settings-page {
    background-color: white;
}

.profile-settings {
    justify-content: space-around;
    align-items: flex-start;
    padding: 0 30px;
}

.left-portion {
    width: 50%;
    padding-right: 30px;
}

.right-portion {
    width: 50%;
    position: sticky;
    top: 110px;
}

.logo__cover {
    justify-content: space-between;
}

.logo {
    width: 35%;
}

.cover {
    width: 60%;
}

.drag {
    background: #FBFDFC;
    border: 1px dashed #DBDBDB;
    border-radius: 7px;
    padding-top: 15px;
    padding-bottom: 15px;
    height: 140px;
}

.image {
    width: 100px;
    height: 120px;
    border: 1px solid #E3E3E3;
    box-sizing: border-box;
    border-radius: 3px;
    position: relative;
}

.cover-image {
    width: 80%;
}

.image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.delete-image {
    background-color: rgba(53, 52, 52, 0.47);
    border-radius: 50%;
    position: absolute;
    right: 5px;
    top: 5px;
}

.upload, button {
    background: #F3F9F6;
    border-radius: 3px;
    width: 100%;
    margin-top: 10px;
    height: 40px;
    font-size: 0.85rem;
}

.forms {
    padding: 20px 0;
}

.forms label {
    color: var(--primary-font);
    font-size: 0.85rem;
}

.checkbox-label {
    color: #333333;
    font-size: 0.9rem;
}

.save {
    margin-top: 30px;
    background-color: var(--primary-color);
    color: white;
    font-size: 1rem;
    border-radius: 3px;
    height: 50px;
}

.save:disabled {
    background-color: #AFB5B2;
}

.send-otp {
    margin-top: -3px;
    height: 30px;
    width: 80px;
}
@media all and (min-width : 1400px) {
    .left-portion {
        width: 40%;
    }

    .right-portion {
        width: 40%;
    }
}
</style>